module.exports = __webpack_public_path__ + "static/media/rate-load.fbd472ea.svg";